import { j as e } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as r } from "react";
import { I as s } from "../../../../IconBase-CxZyIWw2.js";
const t = r((l, i) => /* @__PURE__ */ e.jsx(
  s,
  {
    ref: i,
    ...l,
    image: (o) => /* @__PURE__ */ e.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...o,
        children: [
          /* @__PURE__ */ e.jsx("g", { clipPath: "url(#clip0_3410_69140)", children: /* @__PURE__ */ e.jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m4-7V7H4v2z",
              clipRule: "evenodd"
            }
          ) }),
          /* @__PURE__ */ e.jsx("defs", { children: /* @__PURE__ */ e.jsx("clipPath", { id: "clip0_3410_69140", children: /* @__PURE__ */ e.jsx("path", { fill: "#fff", d: "M0 0h16v16H0z" }) }) })
        ]
      }
    )
  }
));
t.displayName = "CircleRemoveIcon";
export {
  t as CircleRemoveIcon,
  t as default
};
//# sourceMappingURL=index.js.map
